import React from 'react'
import PropTypes from "prop-types"
import { connect } from 'react-redux'

import { updateProduct } from '../ducks/products'
import { getProductForUrl, getReadyState } from '../selectors'

import Product from './Product'

const ProductPage = ({ ready, product }) => (
  (!ready || !product)
    ? (<p>Loading...</p>)
    : (<div><Product product={product} /></div>)
)

ProductPage.propTypes = {
  ready: PropTypes.bool.isRequired,
  product: PropTypes.object.isRequired,
}

const mapStateToProps = (state, props) => ({
  ready: getReadyState(state, props),
  product: getProductForUrl(state, props),
})

const mapDispatchToProps = dispatch => ({
  onChange: (id, changes) => dispatch(updateProduct(id, changes))
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(ProductPage)
